<template>
    <div style="background-color: white;">
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Print Challan
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_challan_data != null" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <div class="main" v-if="learner_challan_data != null" style="border: 1px solid black;max-width: 800px;margin: auto;">
                <v-col cols="12" sm="12" md="12">
                    <div style="text-align: center; margin-top: -10px;">
                        <img :src="org_basic_data.trust_logo" width="140px" alt="logo" />
                    </div>
                    <div style="text-align: center; margin-top: -10px;">
                        Fee Invoice | {{ learner_challan_data.semester }} | {{ learner_challan_data.ay }}
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense style="margin-top: -15px;">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none;"><strong>Name : </strong>{{ learner_challan_data.name }}</td>
                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none;"><strong>Academic Year :</strong> {{ learner_challan_data.ay }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;"><strong>Grade :</strong> {{ learner_challan_data.standard }} <span v-if="learner_challan_data.section!='Pre-primary'">({{ learner_challan_data.quota }})</span></td>
                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Invoice Date :</strong> {{ learner_challan_data.invoice_date }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;"><strong>Parent's Name :</strong> {{ learner_challan_data.parent_name }}</td>
                                    <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Due Date :</strong> {{ learner_challan_data.due_date }}</td>
                                </tr>

                                <tr>
                                    <th style="text-align: center; color: black;">Sr.No</th>
                                    <th style="text-align: center; color: black;">Head</th>
                                    <th style="text-align: center; color: black;">Term Due</th>
                                    <th style="text-align: center; color: black;">Waiver</th>
                                    <th style="text-align: center; color: black;">Due Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in learner_challan_data.student_invoice_details" :key="index">
                                    <td>{{ item.srno }}</td>
                                    <td>{{ item.component }}</td>
                                    <td>{{ item.amount }}</td>
                                    <td>{{ item.waived_amount }}</td>
                                    <td>{{ item.due_amount }}</td>
                                </tr>
                                <tr>
                                    <td colspan="4" style="text-align: center; font-weight: bolder; text-transform: uppercase;">Total Due Amount</td>
                                    <td>{{ learner_challan_data.total_fees_amount }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <div class="main">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tr>
                                    <td style="text-align: center;"><strong>Amount in words : </strong>{{ learner_challan_data.amount_in_words }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <!-- {{installments_details}} -->                    
                    <div>
                        <div> <p style="font-size: small; margin-bottom: -0.5px;">
                        <b>Policy :</b><br> 
                        <b>OTHER TERMS AND CONDITIONS :</b> <br> 
                        <b>FEE PAYMENT SCHEDULE </b><br> 
                        Parents are responsible to ensure that the fee is paid by the due date as per the following schedule. </p> 
                        </div>
                     </div>
                     <v-simple-table dense>  
                         <thead>
                                <tr>
                                    <th style="text-align: center; color: black;">Installment</th>                                                 
                                    <th style="text-align: center; color: black;">Due Date</th>        
                                </tr>
                         </thead>                                         
                            <tbody>
                                <tr v-for="(item, index) in installments_details" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.due_date }}</td>                                    
                                </tr>                                
                            </tbody>                        
                    </v-simple-table>                    
                </div>
                <div style="display:flex; padding-left: 17px; margin-top: 5px;">
                    <div style="flex-direction: column;" >
                        <p style="font-size: small;">
                            <b>Payment Mode Options:</b><br>
                            A Cheque/Demand draft may be given in favor of :<br>
                            <b style="text-transform: uppercase;">{{learner_challan_data.in_favour_of}}</b><br>
                            Payment may be done through NEFT/RTGS as per the<br>
                            following bank details. <b> Beneficiary Name:</b><br>
                            <b style="text-transform: uppercase;">{{learner_challan_data.beneficiary_name}}</b><br>
                            <b>Bank Name:</b> {{learner_challan_data.bank_name}}<br>
                            <b>Account Holder Name:</b> {{learner_challan_data.in_favour_of}} <br>
                            <b>Account No.</b> {{learner_challan_data.account_no}}<br>
                            <b>Account Type:</b> {{learner_challan_data.account_type}}<br>
                            <b>IFSC Code:</b> {{learner_challan_data.ifsc_code}}<br>
                            <b>Swift Code (for international transfers):</b> KKBKINBB <br>
                            <b>Branch:</b> {{learner_challan_data.bank_branch}}<br>                              
                        </p>
                    </div>
                    <div style=" border-style: solid; border-width: 3px;padding-top:5px;margin-top:15px; width:35%;text-align:center;margin-left:52px; font-size: medium;">
                        <b> QR code </b><br>
                        <b> Universal Wisdom School </b><br><br>
                        <div> 
                            <img :src="learner_challan_data.qrcode_path" alt="QR code" width="120" height="120">
                        </div> 
                    </div>
                    <br>
                </div>
                <p style="font-size: small; padding-left: 17px;"> 
                        <b>Please Note:</b><br> 
                            Fee paid after the due date will attract a late payment penalty at a rate of Rs. 500 per day. NonPayment of Fee for aperiod of 30 days after the due date shall automatically result in cancellation of the student’s name from the class list.
                            A re-enrollment fee will be charged if the child wishes to continue after cancellation of the enrollment. There will be a penalty of Rs. 1000/- on dishonoured cheques. No withdrawals are permitted in the middle of the term. In case of unavoidable situations where withdrawing the student is imperative,
                            a notice period of a minimum of 3 months is required to be submitted to the School. No refund can be claimed from the school in case of Mid-Term withdrawal. 
                </p> 
            </div>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import CryptoJS from 'crypto-js';
    import QrcodeVue from "qrcode.vue";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        // props: {
        //     receipt_no: String,
        //     registration_no: String,
        //     ay:Number,
        // },
        components: {
            QrcodeVue,
        },
        data() {
            return {
                overlay: false,
                learner_challan_data: null,
                radios: null,
                challan_no: null,
                registration_no: null,
                ay: null,
                org_basic_data: [],
                installments_details:[],
                encryptedData: null, // Assuming you'll get this from URL or other source
                decryptedData: null
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            const data = this.$route.query.data;
            if(data){
                this.encryptedData = data.replaceAll(" ","+")
                if (this.encryptedData) {
                    this.decryptData(this.encryptedData);
                }
            }
        },
        mounted() {
           this.Eps_uid = localStorage.getItem("EPS-uid");
        //    if(this.$session.get("challan_no")){
        //         this.challan_no = JSON.parse(this.$session.get("challan_no"));
        //    }else{
        //         this.challan_no = this.decryptedData.invoice_id
        //    }
        //    if(this.$session.get("ay")){
        //         this.ay = JSON.parse(this.$session.get("ay"));
        //    }
        //     else{
        //         this.ay = this.decryptedData.ay
        //     }
        //     if(this.$session.get("registration_no")){
        //         this.registration_no = JSON.parse(this.$session.get("registration_no"));
        //     }
        //     else{
        //         this.registration_no = this.decryptedData.lid
        //     }
            if(this.decryptedData){
                this.challan_no = this.decryptedData.invoice_id
                this.registration_no = this.decryptedData.lid
                this.ay = this.decryptedData.ay
                this.getData_mail();
            }else{
                this.challan_no = JSON.parse(this.$session.get("challan_no"));
                this.registration_no = JSON.parse(this.$session.get("registration_no"));
                this.ay = JSON.parse(this.$session.get("ay"));
                this.getData();
            }
        },
        methods: {
            decryptData(text) {
                this.decryptedData = null
                var cryptojs = require('crypto-js');
                var encryptedBase64Key = process.env.VUE_APP_API_PARAMS_KEY;
                var parsedBase64Key = cryptojs.enc.Base64.parse(encryptedBase64Key);
                var decryptedData = cryptojs.AES.decrypt( text, parsedBase64Key, {
                mode: cryptojs.mode.ECB,
                padding: cryptojs.pad.Pkcs7
                } );
                var decryptedText = decryptedData.toString( cryptojs.enc.Utf8 );
                this.decryptedData = JSON.parse(decryptedText)
                return this.decryptedData 
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData_mail(){
                const formData = {
                    challan_no: this.challan_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                    org: this.decryptedData.org,
                    tenant_name: this.decryptedData.tenant_name
                };
                axios
                    .post("/GenerateChallan/getStudentFeesInvoice_from_mail", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_challan_data = res.data.student_challan_details;
                            this.org_basic_data = res.data.org_basic_data;
                            this.installments_details = res.data.installments_details;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
            getData() {
                this.overlay = true;
                this.learner_challan_data = null;
                const formData = {
                    challan_no: this.challan_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                };
                axios
                    .post("/GenerateChallan/getStudentFeesInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_challan_data = res.data.student_challan_details;
                            this.org_basic_data = res.data.org_basic_data;
                            this.installments_details = res.data.installments_details;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }

    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        .main {
            padding-left: 20px;
            padding-right: 20px;
            margin-top: -10px;
        }
        th {
            white-space: nowrap;
        }
        @page {
            size: A4 !important;
            margin-top: none;
            padding-top: none;
        }
    }
   
    .main {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
